import * as h from "react";
import { i as x, b as v, E as p, x as n, a as b, d as g, c as u } from "../createReactComponent-58f9bea8.mjs";
import { n as t } from "../property-9daa16cd.mjs";
import { e as k } from "../class-map-2994e95e.mjs";
import { o as m } from "../if-defined-47693dfa.mjs";
import { S as w } from "../slot-controller-fa97ce97.mjs";
var y = Object.defineProperty, f = Object.getOwnPropertyDescriptor, a = (r, o, i, l) => {
  for (var d, s = l > 1 ? void 0 : l ? f(o, i) : o, c = r.length - 1; c >= 0; c--)
    (d = r[c]) && (s = (l ? d(o, i, s) : d(s)) || s);
  return l && s && y(o, i, s), s;
}, $ = ((r) => (r.BASE = "base", r.BASE_ALT = "base-alt", r))($ || {});
class e extends p {
  constructor() {
    super(...arguments), this.href = "", this.title = "", this.label = "", this.describedby = "", this.variant = "base", this.rel = "noreferrer noopener", this.selected = !1, this.slotController = new w(this, "footer", "header");
  }
  getHeader() {
    return this.slotController.test("header") ? n`<div class="header">
        <slot name="header"></slot>
      </div>` : b;
  }
  getFooter() {
    return this.slotController.test("footer") ? n`<div class="footer">
        <slot name="footer"></slot>
      </div>` : b;
  }
  handleClick(o) {
    this.dispatchCustomEvent("click"), o.stopPropagation();
  }
  render() {
    return n`
      <a
        class="${k({ tile: !0, base: this.variant === "base" && !this.selected, "base-alt": this.variant === "base-alt" && !this.selected, "base-selected": this.selected && this.variant === "base", "base-alt-selected": this.selected && this.variant === "base-alt" })}"
        href="${m(this.href ? this.href : void 0)}"
        target="${this.target}"
        rel="${this.rel}"
        title=${this.title}
        aria-label=${this.label}
        aria-describedby=${this.describedby}
        aria-selected=${this.selected}
        part="tile"
        @click=${(o) => !this.href && this.handleClick(o)}
      >
        ${this.getHeader()}

        <div class="content">
          <slot></slot>
          ${this.getFooter()}
        </div>
      </a>
    `;
  }
}
e.styles = x`
    ${v(`:host{display:block;width:400px;outline:none;--exo-component-tile-padding: var(--exo-spacing-standard) var(--exo-spacing-medium)}:host .tile{display:block;width:100%;height:100%;border-radius:var(--exo-spacing-x-small);border:1px solid var(--exo-color-border-secondary);overflow:hidden;box-shadow:var(--exo-box-shadow-weak);cursor:pointer;transition:.1s background-color ease,.1s box-shadow ease;text-decoration:none;color:unset}:host .tile .content{padding:var(--exo-component-tile-padding)}:host .tile:hover{box-shadow:var(--exo-box-shadow-moderate)}:host .tile:active{box-shadow:var(--exo-box-shadow-weak)}:host .tile:focus-visible,:host .tile:focus{box-shadow:var(--exo-box-shadow-moderate);outline:none;border:2px solid var(--exo-color-background-action-hover)}:host .tile.base{background:var(--exo-color-background)}:host .tile.base:active{background:var(--exo-color-background-secondary)}:host .tile.base-alt{background:var(--exo-color-background-secondary)}:host .tile.base-alt:active{background:var(--exo-color-background-tertiary-selected-weak)}:host .tile.base-selected{border:var(--exo-spacing-4x-small) solid var(--exo-color-background-selected);box-shadow:var(--exo-box-shadow-moderate);background:var(--exo-color-background-selected-weak)}:host .tile.base-selected:focus-visible{border:var(--exo-spacing-3x-small) solid var(--exo-color-background-selected)}:host .tile.base-selected:active{box-shadow:none;background:var(--exo-color-background-secondary)}:host .tile.base-alt-selected{border:var(--exo-spacing-4x-small) solid var(--exo-color-background-selected);box-shadow:var(--exo-box-shadow-moderate);background:var(--exo-color-background)}:host .tile.base-alt-selected:focus-visible{border:var(--exo-spacing-3x-small) solid var(--exo-color-background-selected)}:host .tile.base-alt-selected:active{box-shadow:none;background:var(--exo-color-background-tertiary-selected-weak)}
`)}
  `, a([t()], e.prototype, "href", 2), a([t()], e.prototype, "target", 2), a([t()], e.prototype, "title", 2), a([t()], e.prototype, "label", 2), a([t()], e.prototype, "describedby", 2), a([t()], e.prototype, "variant", 2), a([t()], e.prototype, "rel", 2), a([t({ type: Boolean })], e.prototype, "selected", 2);
const C = g("ex-tile", e), P = u({ tagName: "ex-tile", elementClass: e, react: h, events: { onClick: "click" }, displayName: "ExTile", registerWebComponent: C });
export {
  P as ExTile,
  $ as TileVariant,
  C as register
};
